import { api, getToken } from './client';

export const funcionariosApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/funcionarios${qs ? `?${qs}` : ''}`);
  },
  listarAtivosLista: () => api.get('/funcionarios/ativos-lista'),
  obter: (id) => api.get(`/funcionarios/${id}`),
  criar: (dados) => api.post('/funcionarios', dados),
  atualizar: (id, dados) => api.put(`/funcionarios/${id}`, dados),
  demitir: (id) => api.del(`/funcionarios/${id}`),
  obterFilhos: (id) => api.get(`/funcionarios/${id}/filhos`),
  salvarFilhos: (id, itens) => api.put(`/funcionarios/${id}/filhos`, { itens })
};

export const documentosApi = {
  listar: (funcionarioId) => api.get(`/funcionario-documentos/${funcionarioId}`),
  excluir: (id) => api.del(`/funcionario-documentos/arquivo/${id}`),
  enviar: async (funcionarioId, arquivo) => {
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    const res = await fetch(`/api/funcionario-documentos/${funcionarioId}`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${getToken()}` },
      body: formData
    });
    const corpo = await res.json();
    if (!res.ok) throw new Error(corpo.erro || 'Erro ao enviar documento');
    return corpo;
  }
};

export const beneficiosApi = {
  obter: (funcionarioId) => api.get(`/beneficios/${funcionarioId}`),
  salvar: (funcionarioId, dados) => api.put(`/beneficios/${funcionarioId}`, dados)
};

export const ajustesFinanceirosApi = {
  listar: (mes, ano, funcionarioId) => api.get(`/ajustes-financeiros?mes=${mes}&ano=${ano}${funcionarioId ? `&funcionario_id=${funcionarioId}` : ''}`),
  criar: (dados) => api.post('/ajustes-financeiros', dados),
  excluir: (id) => api.del(`/ajustes-financeiros/${id}`)
};

export const pontoApi = {
  listar: (mes, ano) => api.get(`/ponto?mes=${mes}&ano=${ano}`),
  salvar: (funcionarioId, dados) => api.put(`/ponto/${funcionarioId}`, dados)
};

export const folhaPagamentoApi = {
  obterConfig: () => api.get('/folha-pagamento/config'),
  salvarConfig: (dados) => api.put('/folha-pagamento/config', dados),
  obterDados: (mes, ano) => api.get(`/folha-pagamento?mes=${mes}&ano=${ano}`),
  obterFechamento: (mes, ano) => api.get(`/folha-pagamento/fechamento?mes=${mes}&ano=${ano}`),
  fechar: (dados) => api.post('/folha-pagamento/fechar', dados)
};

export const feriasApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/ferias${qs ? `?${qs}` : ''}`);
  },
  gerar: (funcionarioId) => api.post(`/ferias/gerar/${funcionarioId}`),
  atualizar: (id, dados) => api.put(`/ferias/${id}`, dados)
};

export const decimoTerceiroApi = {
  listar: (ano) => api.get(`/decimo-terceiro?ano=${ano}`),
  calcular: (ano) => api.post('/decimo-terceiro/calcular', { ano }),
  pagarPrimeira: (id, dataPagamento) => api.post(`/decimo-terceiro/${id}/pagar-primeira`, { data_pagamento: dataPagamento }),
  pagarSegunda: (id, dataPagamento) => api.post(`/decimo-terceiro/${id}/pagar-segunda`, { data_pagamento: dataPagamento })
};

export const rescisaoApi = {
  listar: () => api.get('/rescisao'),
  calcular: (dados) => api.post('/rescisao/calcular', dados),
  criar: (dados) => api.post('/rescisao', dados)
};

export const metasApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/metas${qs ? `?${qs}` : ''}`);
  },
  criar: (dados) => api.post('/metas', dados),
  atualizar: (id, dados) => api.patch(`/metas/${id}`, dados),
  excluir: (id) => api.del(`/metas/${id}`),
  lancarBonificacao: (id) => api.post(`/metas/${id}/lancar-bonificacao`)
};

export const comissoesApi = {
  resumo: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/comissoes/resumo${qs ? `?${qs}` : ''}`);
  },
  detalhe: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/comissoes/detalhe${qs ? `?${qs}` : ''}`);
  }
};
